var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('GlobalSideNavBar'),_c('div',{staticClass:"le-app-router-content"},[_c('router-view')],1),_c('notifications',{attrs:{"position":"top center","ignoreDuplicates":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }